import { Box, Button, Text } from '@rsos/base-components';
import type { TranscriptionStateCall } from '../tabs/TranscriptTab/transcriptionSlice/transcriptionSlice.types';
import TranscriptHistoryRow from './TranscriptHistoryRow';

interface TranscriptHistoryListProps {
  transcriptions: TranscriptionStateCall[];
  onSelect: (transcription: TranscriptionStateCall) => void;
  hasMore?: boolean;
  isLoadingMore?: boolean;
  onLoadMore?: () => void;
}

const TranscriptHistoryList = ({
  transcriptions,
  onSelect,
  hasMore = false,
  isLoadingMore = false,
  onLoadMore = () => undefined,
}: TranscriptHistoryListProps) => {
  if (!transcriptions.length) {
    return (
      <Text textAlign="center" color="secondaryText">
        No recent transcripts found.
      </Text>
    );
  }

  return (
    <Box gridRowGap="8px">
      {transcriptions.map(t => (
        <TranscriptHistoryRow
          key={
            t?.payload?.call_information?.digi_call_id ||
            t?.payload?.call_information?.call_start_time ||
            Math.random()
          }
          transcription={t}
          onClick={() => onSelect(t)}
        />
      ))}
      {hasMore && (
        <Box align="center" mt="8px">
          <Button
            btnType="secondary"
            size="small"
            onClick={onLoadMore}
            disabled={isLoadingMore}
            aria-label="Load more recent transcripts"
          >
            {isLoadingMore ? 'Loading…' : 'Load more'}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default TranscriptHistoryList;
